

import React from "react";

export const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-4 h-4 text-gray-80",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}  {...props}>
            <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.2499 1.75015C12.5151 1.48493 12.8748 1.33594 13.2499 1.33594C13.625 1.33594 13.9847 1.48493 14.2499 1.75015C14.5151 2.01537 14.6641 2.37508 14.6641 2.75015C14.6641 3.12522 14.5151 3.48493 14.2499 3.75015L8.24123 9.75948C8.08293 9.91765 7.88737 10.0334 7.67257 10.0962L5.75723 10.6562C5.69987 10.6729 5.63906 10.6739 5.58117 10.6591C5.52329 10.6442 5.47045 10.6141 5.4282 10.5719C5.38594 10.5296 5.35583 10.4768 5.341 10.4189C5.32617 10.361 5.32717 10.3002 5.3439 10.2428L5.9039 8.32748C5.96692 8.11285 6.08292 7.91752 6.24123 7.75948L12.2499 1.75015Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export const EditV2Icon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-4 h-4 text-purple-70 ",
    ...props
}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}  {...props}>
            <path d="M13.2599 3.59997L5.04985 12.29C4.73985 12.62 4.43985 13.27 4.37985 13.72L4.00985 16.96C3.87985 18.13 4.71985 18.93 5.87985 18.73L9.09985 18.18C9.54985 18.1 10.1799 17.77 10.4899 17.43L18.6999 8.73997C20.1199 7.23997 20.7599 5.52997 18.5499 3.43997C16.3499 1.36997 14.6799 2.09997 13.2599 3.59997Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.8901 5.05005C12.3201 7.81005 14.5601 9.92005 17.3401 10.2" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 22H21" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>


    );
};